<template>
  <div
    :class="{
      cr_form_item_full: size === '12',
      cr_form_item_half: size === '6'
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ["size"]
};
</script>
